// Country to currency mapping utility
// Maps country codes to their respective currencies
import { api } from '../api/httpClient';
import { API_ENDPOINTS } from '../api/config';

export const COUNTRY_CURRENCY_MAP = {
  // North America
  'US': { code: 'USD', name: 'US Dollar' },
  'CA': { code: 'CAD', name: 'Canadian Dollar' },
  'MX': { code: 'MXN', name: 'Mexican Peso' },
  
  // Europe
  'GB': { code: 'GBP', name: 'British Pound' },
  'DE': { code: 'EUR', name: 'Euro' },
  'FR': { code: 'EUR', name: 'Euro' },
  'IT': { code: 'EUR', name: 'Euro' },
  'ES': { code: 'EUR', name: 'Euro' },
  'NL': { code: 'EUR', name: 'Euro' },
  'BE': { code: 'EUR', name: 'Euro' },
  'AT': { code: 'EUR', name: 'Euro' },
  'PT': { code: 'EUR', name: 'Euro' },
  'IE': { code: 'EUR', name: 'Euro' },
  'FI': { code: 'EUR', name: 'Euro' },
  'GR': { code: 'EUR', name: 'Euro' },
  'LU': { code: 'EUR', name: 'Euro' },
  'MT': { code: 'EUR', name: 'Euro' },
  'CY': { code: 'EUR', name: 'Euro' },
  'SK': { code: 'EUR', name: 'Euro' },
  'SI': { code: 'EUR', name: 'Euro' },
  'EE': { code: 'EUR', name: 'Euro' },
  'LV': { code: 'EUR', name: 'Euro' },
  'LT': { code: 'EUR', name: 'Euro' },
  'CH': { code: 'CHF', name: 'Swiss Franc' },
  'NO': { code: 'NOK', name: 'Norwegian Krone' },
  'SE': { code: 'SEK', name: 'Swedish Krona' },
  'DK': { code: 'DKK', name: 'Danish Krone' },
  'PL': { code: 'PLN', name: 'Polish Złoty' },
  'CZ': { code: 'CZK', name: 'Czech Koruna' },
  'HU': { code: 'HUF', name: 'Hungarian Forint' },
  'RO': { code: 'RON', name: 'Romanian Leu' },
  'BG': { code: 'BGN', name: 'Bulgarian Lev' },
  'HR': { code: 'HRK', name: 'Croatian Kuna' },
  'RS': { code: 'RSD', name: 'Serbian Dinar' },
  'AL': { code: 'ALL', name: 'Albanian Lek' },
  'MK': { code: 'MKD', name: 'Macedonian Denar' },
  'MD': { code: 'MDL', name: 'Moldovan Leu' },
  'UA': { code: 'UAH', name: 'Ukrainian Hryvnia' },
  'BY': { code: 'BYN', name: 'Belarusian Ruble' },
  'GE': { code: 'GEL', name: 'Georgian Lari' },
  'AM': { code: 'AMD', name: 'Armenian Dram' },
  'AZ': { code: 'AZN', name: 'Azerbaijani Manat' },
  'KZ': { code: 'KZT', name: 'Kazakhstani Tenge' },
  'KG': { code: 'KGS', name: 'Kyrgyzstani Som' },
  'TJ': { code: 'TJS', name: 'Tajikistani Somoni' },
  'TM': { code: 'TMT', name: 'Turkmenistan Manat' },
  'UZ': { code: 'UZS', name: 'Uzbekistani Som' },
  'MN': { code: 'MNT', name: 'Mongolian Tögrög' },
  
  // Asia
  'JP': { code: 'JPY', name: 'Japanese Yen' },
  'CN': { code: 'CNY', name: 'Chinese Yuan' },
  'KR': { code: 'KRW', name: 'South Korean Won' },
  'IN': { code: 'INR', name: 'Indian Rupee' },
  'SG': { code: 'SGD', name: 'Singapore Dollar' },
  'HK': { code: 'HKD', name: 'Hong Kong Dollar' },
  'TH': { code: 'THB', name: 'Thai Baht' },
  'MY': { code: 'MYR', name: 'Malaysian Ringgit' },
  'ID': { code: 'IDR', name: 'Indonesian Rupiah' },
  'PH': { code: 'PHP', name: 'Philippine Peso' },
  'VN': { code: 'VND', name: 'Vietnamese Dong' },
  'LA': { code: 'LAK', name: 'Lao Kip' },
  'KH': { code: 'KHR', name: 'Cambodian Riel' },
  'MM': { code: 'MMK', name: 'Myanmar Kyat' },
  'BD': { code: 'BDT', name: 'Bangladeshi Taka' },
  'LK': { code: 'LKR', name: 'Sri Lankan Rupee' },
  'NP': { code: 'NPR', name: 'Nepalese Rupee' },
  'PK': { code: 'PKR', name: 'Pakistani Rupee' },
  'AF': { code: 'AFN', name: 'Afghan Afghani' },
  'IR': { code: 'IRR', name: 'Iranian Rial' },
  'IQ': { code: 'IQD', name: 'Iraqi Dinar' },
  'SY': { code: 'SYP', name: 'Syrian Pound' },
  'YE': { code: 'YER', name: 'Yemeni Rial' },
  'IL': { code: 'ILS', name: 'Israeli Shekel' },
  'TR': { code: 'TRY', name: 'Turkish Lira' },
  
  // Africa
  'EG': { code: 'EGP', name: 'Egyptian Pound' },
  'NG': { code: 'NGN', name: 'Nigerian Naira' },
  'KE': { code: 'KES', name: 'Kenyan Shilling' },
  'GH': { code: 'GHS', name: 'Ghanaian Cedi' },
  'UG': { code: 'UGX', name: 'Ugandan Shilling' },
  'TZ': { code: 'TZS', name: 'Tanzanian Shilling' },
  'MA': { code: 'MAD', name: 'Moroccan Dirham' },
  'ZA': { code: 'ZAR', name: 'South African Rand' },
  'BI': { code: 'BIF', name: 'Burundian Franc' },
  'CD': { code: 'CDF', name: 'Congolese Franc' },
  'DJ': { code: 'DJF', name: 'Djiboutian Franc' },
  'ET': { code: 'ETB', name: 'Ethiopian Birr' },
  'GM': { code: 'GMD', name: 'Gambian Dalasi' },
  'GN': { code: 'GNF', name: 'Guinean Franc' },
  'LR': { code: 'LRD', name: 'Liberian Dollar' },
  'MW': { code: 'MWK', name: 'Malawian Kwacha' },
  'MU': { code: 'MUR', name: 'Mauritian Rupee' },
  'MZ': { code: 'MZN', name: 'Mozambican Metical' },
  'NA': { code: 'NAD', name: 'Namibian Dollar' },
  'RW': { code: 'RWF', name: 'Rwandan Franc' },
  'SL': { code: 'SLL', name: 'Sierra Leonean Leone' },
  'SO': { code: 'SOS', name: 'Somali Shilling' },
  'SS': { code: 'SSP', name: 'South Sudanese Pound' },
  'ST': { code: 'STN', name: 'São Tomé and Príncipe Dobra' },
  'SZ': { code: 'SZL', name: 'Eswatini Lilangeni' },
  'TN': { code: 'TND', name: 'Tunisian Dinar' },
  'BF': { code: 'XOF', name: 'West African CFA Franc' },
  'CM': { code: 'XAF', name: 'Central African CFA Franc' },
  'CV': { code: 'CVE', name: 'Cape Verdean Escudo' },
  'KM': { code: 'KMF', name: 'Comorian Franc' },
  'MG': { code: 'MGA', name: 'Malagasy Ariary' },
  'MR': { code: 'MRO', name: 'Mauritanian Ouguiya' },
  
  // Middle East
  'AE': { code: 'AED', name: 'UAE Dirham' },
  'SA': { code: 'SAR', name: 'Saudi Riyal' },
  'QA': { code: 'QAR', name: 'Qatari Riyal' },
  'KW': { code: 'KWD', name: 'Kuwaiti Dinar' },
  'BH': { code: 'BHD', name: 'Bahrain Dinar' },
  'OM': { code: 'OMR', name: 'Omani Rial' },
  'JO': { code: 'JOD', name: 'Jordanian Dinar' },
  'LB': { code: 'LBP', name: 'Lebanese Pound' },
  
  // Oceania
  'AU': { code: 'AUD', name: 'Australian Dollar' },
  'NZ': { code: 'NZD', name: 'New Zealand Dollar' },
  'FJ': { code: 'FJD', name: 'Fijian Dollar' },
  'PG': { code: 'PGK', name: 'Papua New Guinean Kina' },
  'SB': { code: 'SBD', name: 'Solomon Islands Dollar' },
  'VU': { code: 'VUV', name: 'Vanuatu Vatu' },
  'WS': { code: 'WST', name: 'Samoan Tālā' },
  'TO': { code: 'TOP', name: 'Tongan Paʻanga' },
  'KI': { code: 'KID', name: 'Kiribati Dollar' },
  'TV': { code: 'TVD', name: 'Tuvaluan Dollar' },
  'PF': { code: 'XPF', name: 'CFP Franc' },
  
  // South America
  'BR': { code: 'BRL', name: 'Brazilian Real' },
  'AR': { code: 'ARS', name: 'Argentine Peso' },
  'CL': { code: 'CLP', name: 'Chilean Peso' },
  'CO': { code: 'COP', name: 'Colombian Peso' },
  'PE': { code: 'PEN', name: 'Peruvian Sol' },
  'UY': { code: 'UYU', name: 'Uruguayan Peso' },
  'PY': { code: 'PYG', name: 'Paraguayan Guaraní' },
  'BO': { code: 'BOB', name: 'Bolivian Boliviano' },
  'CR': { code: 'CRC', name: 'Costa Rican Colón' },
  'GT': { code: 'GTQ', name: 'Guatemalan Quetzal' },
  'HN': { code: 'HNL', name: 'Honduran Lempira' },
  'NI': { code: 'NIO', name: 'Nicaraguan Córdoba' },
  'PA': { code: 'PAB', name: 'Panamanian Balboa' },
  'DO': { code: 'DOP', name: 'Dominican Peso' },
  'TT': { code: 'TTD', name: 'Trinidad and Tobago Dollar' },
  'JM': { code: 'JMD', name: 'Jamaican Dollar' },
  'BB': { code: 'BBD', name: 'Barbadian Dollar' },
  'AG': { code: 'XCD', name: 'East Caribbean Dollar' },
  'BZ': { code: 'BZD', name: 'Belize Dollar' },
  'GY': { code: 'GYD', name: 'Guyanese Dollar' },
  'SR': { code: 'SRD', name: 'Surinamese Dollar' },
  
  // Caribbean and other territories
  'AN': { code: 'ANG', name: 'Netherlands Antillean Guilder' },
  'AW': { code: 'AWG', name: 'Aruban Florin' },
  'BM': { code: 'BMD', name: 'Bermudian Dollar' },
  'KY': { code: 'KYD', name: 'Cayman Islands Dollar' },
  'FK': { code: 'FKP', name: 'Falkland Islands Pound' },
  'GI': { code: 'GIP', name: 'Gibraltar Pound' },
  'IM': { code: 'IMP', name: 'Manx Pound' },
  'JE': { code: 'JEP', name: 'Jersey Pound' },
  'SH': { code: 'SHP', name: 'Saint Helena Pound' },
  'RU': { code: 'RUB', name: 'Russian Ruble' }
};

/**
 * Get currency information for a given country code
 * @param {string} countryCode - ISO 3166-1 alpha-2 country code
 * @returns {Object|null} Currency object with code and name, or null if not found
 */
export const getCurrencyByCountry = (countryCode) => {
  if (!countryCode) return null;
  
  const upperCountryCode = countryCode.toUpperCase();
  return COUNTRY_CURRENCY_MAP[upperCountryCode] || null;
};

const extractCountryCode = (data) => {
  if (!data) return null;
  return (
    data.country_code ||
    data.countryCode ||
    data.country ||
    data.iso_code ||
    data.isoCode ||
    data.code ||
    null
  );
};

/**
 * Detect user's country and return corresponding currency
 * @returns {Promise<Object|null>} Currency object or null if detection fails
 */
export const detectUserCurrency = async () => {
  try {
    const data = await api.get(API_ENDPOINTS.DETECT_IP);
    const countryCode = extractCountryCode(data);
    if (countryCode) {
      const currency = getCurrencyByCountry(countryCode);
      if (currency) {
        return currency;
      }
    }
  } catch (error) {
    console.log('Backend country detection failed:', error);
  }

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 6000);

    const response = await fetch('http://iploc.caledontech.ca/info/', {
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`IP lookup responded with status ${response.status}`);
    }

    const data = await response.json();
    const countryCode = extractCountryCode(data);

    if (countryCode) {
      const currency = getCurrencyByCountry(countryCode);
      if (currency) {
        // console.log(`Detected country: ${data.country_name} (${countryCode}), Currency: ${currency.code}`);
        return currency;
      }
    }
  } catch (error) {
    console.log('IP-based location detection failed:', error);
  }
  
  try {
    // Fallback to browser geolocation
    if (navigator.geolocation) {
      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            try {
              const { latitude, longitude } = position.coords;
              const response = await fetch(
                `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
              );
              const data = await response.json();
              
              if (data.countryCode) {
                const currency = getCurrencyByCountry(data.countryCode);
                if (currency) {
                  // console.log(`Detected country from coordinates: ${data.countryName} (${data.countryCode}), Currency: ${currency.code}`);
                  resolve(currency);
                } else {
                  resolve(null);
                }
              } else {
                resolve(null);
              }
            } catch (geoError) {
              // console.log('Geolocation reverse lookup failed:', geoError);
              resolve(null);
            }
          },
          (error) => {
            // console.log('Browser geolocation failed:', error);
            resolve(null);
          },
          { timeout: 10000, enableHighAccuracy: false }
        );
      });
    }
  } catch (error) {
    console.log('Geolocation not available:', error);
  }
  
  return null;
};

/**
 * Get default currency based on user's location or fallback to USD
 * @returns {Promise<Object>} Currency object
 */
export const getDefaultCurrency = async () => {
  const detectedCurrency = await detectUserCurrency();
  
  if (detectedCurrency) {
    return detectedCurrency;
  }
  
  // Fallback to USD
  // console.log('Using fallback currency: USD');
  return { code: 'USD', name: 'US Dollar' };
};
